






































































































































































































import { computed, defineComponent, reactive, ref } from "@vue/composition-api";
import Layout from "@/components/Atoms/Layout/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import PageHeader from "@/components/Molecules/PageHeader/index.vue";
import ListFilter from "@/components/Molecules/ListFilter/index.vue";
import FilterSection from "@/components/Molecules/FilterSection/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccSearchMultiSelectbox from "@/components/Atoms/OccSearchMultiSelectbox/index.vue";
import OccSearchSelectbox from "@/components/Atoms/OccSearchSelectbox/index.vue";
import OccToast from "@/components/Atoms/OccToast/index.vue";
import Checkbox from "@/components/Atoms/Forms/Checkbox/index.vue";
import SearchTextField from "@/components/Atoms/Forms/SearchTextField/index.vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import { Props } from "@/components/Molecules/ListTable/index.vue";
import OccAlertFloating from "@/components/Molecules/OccAlert/Floating/index.vue";
import { SelectItem } from "@/components/Atoms/OccSelectbox/types";
import PartnerEntryUsersTable from "./Organisms/PartnerEntryUsersTable.vue";
import FixedFooter from "./Organisms/FixedFooter.vue";
import CsvCustomizeModal from "@/components/Organisms/CsvCustomizeModal/index.vue";
import SelectionStatusBulkChangeModal from "./Organisms/SelectionStatusBulkChangeModal.vue";
import SelectionStatusChangeDrawer from "./Organisms/SelectionStatusChangeDrawer.vue";
import TableFooter from "@/components/Molecules/TableFooter/index.vue";
import ConfirmModal from "@/components/Organisms/modals/ConfirmModal/index.vue";
import DateRangeSelector from "@/components/Molecules/DateRangeSelector/index.vue";
import HelpLink from "@/components/Atoms/HelpLink/index.vue";

import {
  getPartnerEntryUsers,
  getPartnerEntryUserSearchOptions,
  updatePartnerEntryUserStar,
  deletePartnerEntryUserStar,
  startGeneratePartnerEntryUsersCsv,
  getPartnerEntryCsvColumns,
  upsertPartnerEntryCsvColumns
} from "@/api";
import { useRequest } from "@/helpers/hooks/useRequest";
import { useToggle } from "@/helpers/hooks/useToggle";
import {
  PRIVILEGE_ENTRIES_DOWNLOAD,
  hasPrivilege
} from "@/helpers/privilege-helper";
import {
  selectListGenerator,
  allEventStatusSearchOptions
} from "@/helpers/partnerEntryUsers";
import {
  ApiRequest,
  ApiResponse,
  PartnerEntryUserEventStatus,
  PartnerEntryUserFilterCondition,
  PartnerEntryUserFilterData,
  PartnerEntryUserFilterName,
  PartnerEntryUserSelectionStatus,
  Order
} from "@/api/types";
import { CsvColumns } from "@/components/Organisms/CsvCustomizeModal/types";
import { useRouter } from "@/router";

export default defineComponent({
  components: {
    Layout,
    OccHeading,
    PageHeader,
    ListFilter,
    FilterSection,
    OccButton,
    OccSearchMultiSelectbox,
    OccSearchSelectbox,
    OccToast,
    Checkbox,
    SearchTextField,
    LoadingView,
    OccAlertFloating,
    PartnerEntryUsersTable,
    FixedFooter,
    CsvCustomizeModal,
    SelectionStatusBulkChangeModal,
    SelectionStatusChangeDrawer,
    TableFooter,
    ConfirmModal,
    DateRangeSelector,
    HelpLink
  },
  name: "PartnerEntryUsers",
  setup() {
    const [{ data: searchOptions, loading: searchOptionsLoading }] = useRequest(
      () => getPartnerEntryUserSearchOptions(),
      {
        immediate: true
      }
    );
    const router = useRouter();

    const searchParamsEntryRoute = computed<string[]>(() => {
      const entryRoute = [];

      if (filterState.entryRoute.some(event => event === 0)) {
        entryRoute.push("scout");
      }
      if (filterState.entryRoute.some(event => event !== 0)) {
        entryRoute.push("event");
      }

      return entryRoute;
    });

    const searchParamsEventIds = computed<number[]>(() => {
      return filterState.entryRoute.filter(event => event !== 0);
    });

    const searchParams = computed<ApiRequest.PartnerEntryUsers>(() => {
      const params: ApiRequest.PartnerEntryUsers = {
        search_text: filterState.searchText,
        starred: filterState.like || undefined,
        unlottery: filterState.unlottery || undefined,
        universities: filterState.universities,
        graduate_years: filterState.graduateYears,
        grades: filterState.grades,
        selection_status: filterState.selectionStatus,
        event_status: filterState.eventStatus,
        entry_route: searchParamsEntryRoute.value,
        events: searchParamsEventIds.value,
        schedules: filterState.schedules,
        order: sortState.order,
        limit: displayCount.value,
        offset: displayCount.value * (currentPage.value - 1)
      };

      // APIとしては空文字が渡されると都合が悪い（optional params）ので、空文字の場合はパラメータをセットしないようにしています
      if (filterState.entryDate.from !== "") {
        params.entry_date_start = filterState.entryDate.from;
      }
      if (filterState.entryDate.to !== "") {
        params.entry_date_end = filterState.entryDate.to;
      }

      return params;
    });

    const [
      { data: partnerEntryUsers, loading: usersLoading },
      runGetPartnerEntryUsers
    ] = useRequest(() => getPartnerEntryUsers(searchParams.value), {
      immediate: true
    });

    const [
      isShowSelectionStatusBulkChangeModal,
      toggleIsShowSelectionStatusBulkChangeModal
    ] = useToggle(false);

    const headers = reactive<Props["headers"]>([
      {
        name: "応募者名",
        subHeaders: [{ name: "識別コード" }, { name: "カナ" }],
        sizeInner: "100px",
        minSizeContainer: "180px"
      },
      {
        name: "大学",
        subHeaders: [{ name: "卒年" }, { name: "学部・学年" }],
        sizeInner: "100px",
        minSizeContainer: "220px"
      },
      {
        name: "選考ステータス",
        sizeInner: "100px",
        minSizeContainer: "140px"
      },
      {
        name: "応募経路",
        subHeaders: [
          { name: "イベント種別" },
          { name: "応募日時", sortParam: "order_date", order: "asc" }
        ],
        minSizeContainer: "250px"
      },
      {
        name: "応募スケジュール",
        subHeaders: [{ name: "スケジュール開催日" }],
        minSizeContainer: "250px"
      },
      {
        name: "イベントステータス",
        sizeInner: "130px",
        minSizeContainer: "170px"
      }
    ]);

    const hasCsvDownloadPriviledge = hasPrivilege(PRIVILEGE_ENTRIES_DOWNLOAD);

    /** ========================================
     * フィルタ
     * ========================================*/
    const filterState = reactive<PartnerEntryUserFilterData>({
      searchText: "",
      like: false,
      unlottery: false,
      universities: [] as string[],
      graduateYears: [] as string[],
      grades: [] as string[],
      selectionStatus: [] as PartnerEntryUserSelectionStatus[],
      eventStatus: [] as PartnerEntryUserEventStatus[],
      entryRoute: [] as number[],
      schedules: [] as number[],
      entryDate: { from: "", to: "" }
    });

    const handleChangedEntryDateFrom = (value: string) => {
      filterState.entryDate.from = value;
    };

    const handleChangedEntryDateTo = (value: string) => {
      filterState.entryDate.to = value;
    };

    const leftListFilterConditions: PartnerEntryUserFilterCondition[] = [
      {
        label: "お気に入り",
        checkbox_label: "お気に入りのみ表示",
        name: "like",
        type: "checkbox"
      },
      {
        label: "大学",
        name: "universities",
        type: "multiSelectbox"
      },
      {
        label: "卒年",
        name: "graduateYears",
        type: "multiSelectbox"
      },
      {
        label: "学年",
        name: "grades",
        type: "multiSelectbox"
      },
      {
        label: "選考ステータス",
        name: "selectionStatus",
        type: "multiSelectbox"
      }
    ];

    const rightListFilterConditions: PartnerEntryUserFilterCondition[] = [
      {
        label: "抽選",
        checkbox_label: "未抽選のみ表示",
        name: "unlottery",
        type: "checkbox"
      },
      {
        label: "初回応募日",
        name: "entryDate",
        type: "dateRange"
      },
      {
        label: "イベントステータス",
        name: "eventStatus",
        type: "multiSelectbox"
      },
      {
        label: "応募経路",
        name: "entryRoute",
        type: "multiSelectbox"
      },
      {
        label: "応募スケジュール",
        name: "schedules",
        type: "multiSelectbox"
      }
    ];

    const listFilterConditions: PartnerEntryUserFilterCondition[] = [
      ...leftListFilterConditions,
      ...rightListFilterConditions
    ];

    const filterCount = ref(0);

    const entryRouteSelectItemList = computed(() => {
      if (!searchOptions.value || searchOptions.value.events === undefined) {
        return [];
      }
      const events = searchOptions.value.events.map(
        (v: ApiResponse.PartnerEntryUserEventSelectItem) => {
          return {
            value: v.id,
            label: v.title
          };
        }
      );

      // 応募経路としてスカウトを追加する。valueにはevent_idが入るが、スカウトの場合は0固定とする。
      return [{ value: 0, label: "スカウト" }, ...events];
    });

    const scheduleSelectItemList = computed(() => {
      if (!searchOptions.value) return [];
      return filterState.entryRoute.reduce(
        (prev: SelectItem<number>[], event_id: number) => {
          // イベントID=0はスカウト。スケジュールは存在しないためひとつ前の結果をそのまま返却する。
          if (event_id === 0) return prev;

          const schedules =
            searchOptions.value?.event_schedules[event_id].schedules;
          if (!schedules) return prev;

          const tmpSchedulesItemList = schedules.map(
            (v: ApiResponse.PartnerEntryUserScheduleSelectItem) => {
              return {
                value: v.id,
                label: v.title
              };
            }
          );
          return prev.concat(tmpSchedulesItemList);
        },
        []
      );
    });

    const selectItemList = computed(() => {
      return {
        universities: selectListGenerator(
          searchOptions.value?.universities || []
        ),
        graduateYears: selectListGenerator(
          searchOptions.value?.graduate_years || []
        ),
        grades: selectListGenerator(searchOptions.value?.grades || []),
        selectionStatus: searchOptions.value?.selection_statuses || [],
        eventStatus: allEventStatusSearchOptions || [],
        entryRoute: entryRouteSelectItemList.value,
        schedules: scheduleSelectItemList.value
      };
    });

    const hasSelectedEvent = computed<boolean>(() => {
      return filterState.entryRoute.length > 0;
    });

    const onChangeCheckbox = (
      key: Extract<PartnerEntryUserFilterName, "like" | "unlottery">,
      newVal: boolean[]
    ) => {
      filterState[key] = newVal[0];
    };

    const onChangeMultiSelect = (
      key: Exclude<
        PartnerEntryUserFilterName,
        "like" | "unlottery" | "entryDate"
      >,
      newVal: (
        | string
        | PartnerEntryUserSelectionStatus
        | PartnerEntryUserEventStatus
      )[]
    ) => {
      filterState[key] = newVal as any;
    };

    const onSearchText = async () => {
      moveFiresPage();
      await runGetPartnerEntryUsers();
    };

    const onSubmitFilter = async () => {
      moveFiresPage();
      await runGetPartnerEntryUsers();
      setCurrentFilterCount();
    };

    const onResetFilter = async () => {
      filterState.searchText = "";

      listFilterConditions.forEach(condition => {
        const key: keyof typeof filterState = condition.name;
        switch (key) {
          case "like":
          case "unlottery":
            filterState[key] = false;
            return;
          case "universities":
          case "graduateYears":
          case "grades":
          case "selectionStatus":
          case "eventStatus":
          case "entryRoute":
          case "schedules":
            filterState[key] = [];
            return;
          case "entryDate":
            filterState[key] = { from: "", to: "" };
            return;
        }
      });
      moveFiresPage();
      await runGetPartnerEntryUsers();
      setCurrentFilterCount();
    };

    const setCurrentFilterCount = () => {
      const currentFilterCount = listFilterConditions.reduce(
        (preFilterCount: number, condition) => {
          const key: keyof typeof filterState = condition.name;
          switch (key) {
            case "like":
            case "unlottery":
              if (filterState[key]) {
                return preFilterCount + 1;
              } else {
                return preFilterCount;
              }
            case "universities":
            case "graduateYears":
            case "grades":
            case "selectionStatus":
            case "eventStatus":
            case "entryRoute":
            case "schedules":
              if (filterState[key].length) {
                return preFilterCount + 1;
              } else {
                return preFilterCount;
              }
            case "entryDate":
              if (filterState[key].from || filterState[key].to) {
                return preFilterCount + 1;
              } else {
                return preFilterCount;
              }
            default:
              return preFilterCount;
          }
        },
        0
      );
      filterCount.value = currentFilterCount;
    };

    /** ========================================
     * ページネーション
     * ========================================*/
    const currentPage = ref(1);

    const displayCount = ref(25);

    const displayCountSelectList = [
      { value: 25, label: "25件" },
      { value: 50, label: "50件" },
      { value: 100, label: "100件" }
    ];

    const totalPageCount = computed(() => {
      if (!partnerEntryUsers.value || !partnerEntryUsers.value.total) {
        return 1;
      }
      return Math.ceil(partnerEntryUsers.value?.total / displayCount.value);
    });

    const moveFiresPage = () => {
      currentPage.value = 1;
    };

    const onChangePage = async (pageNumber: number) => {
      currentPage.value = pageNumber;
      await runGetPartnerEntryUsers();
    };

    const onChangeDisplayCount = async (count: number) => {
      displayCount.value = count;
      moveFiresPage();
      await runGetPartnerEntryUsers();
    };

    /** ========================================
     * ソート
     * ========================================*/
    const sortState = reactive<Pick<ApiRequest.PartnerEntryUsers, "order">>({
      order: "desc"
    });

    const onChangeOrderSubColumn = async (
      order: Order,
      headerIndex: number,
      subHeaderIndex: number
    ) => {
      const header = headers[headerIndex];
      const subHeader = header.subHeaders && header.subHeaders[subHeaderIndex];
      if (!subHeader) return;

      sortState.order = order;
      subHeader.order = order;
      moveFiresPage();

      await runGetPartnerEntryUsers();
    };

    /** ========================================
     * お気に入り
     * ========================================*/
    const toggleStar = (partnerEntryUserId: number, value: boolean) => {
      const params = {
        partner_entry_user_id: partnerEntryUserId
      };

      let record = (partnerEntryUsers.value as ApiResponse.PartnerEntryUserList).records.find(
        user => user.partner_entry_user.id === partnerEntryUserId
      );
      if (!record) return;

      // TODO: 更新レコードIDと更新結果をAPIで受け取り、それをもとに更新する
      record.star = value;

      value
        ? updatePartnerEntryUserStar(params)
        : deletePartnerEntryUserStar(params);
    };

    /** ========================================
     * モーダル
     * ========================================*/
    const csvCustomizeModalShow = ref<boolean>(false);

    const closeCsvCustomizeModal = () => {
      csvCustomizeModalShow.value = false;
    };

    const showCsvCustomizeModal = async () => {
      await runGetPartnerEntryCsvColumns();
      csvCustomizeModalShow.value = true;
    };

    const bulkEditConfirmModalShow = ref<boolean>(false);

    const closeSelectionStatusBulkChangeModal = () => {
      bulkEditConfirmModalShow.value = false;
    };

    const showSelectionStatusBulkChangeModal = () => {
      bulkEditConfirmModalShow.value = true;
    };

    /** ========================================
     * 行選択
     * ========================================*/
    const selectedRowList = ref<ApiResponse.PartnerEntryUser[]>([]);

    const selectedRowCount = computed(() => selectedRowList.value.length);

    const onChangeRowValue = (list: ApiResponse.PartnerEntryUser[]) => {
      selectedRowList.value = list;
    };

    const resetRowList = () => {
      selectedRowList.value = [];
    };

    /** ========================================
     * CSV出力カラムの管理
     * ========================================*/
    const availableCsvColumns = [
      { name: "created_at", label: "応募日時" },
      { name: "unique_id", label: "識別コード" },
      { name: "name", label: "名前" },
      { name: "name_kana", label: "名前（カナ）" },
      { name: "university_name", label: "大学" },
      { name: "department_name", label: "学部" },
      { name: "email", label: "大学メールアドレス" },
      { name: "internship_results", label: "インターン実績" },
      { name: "high_school", label: "出身高校名" },
      { name: "activities", label: "学生時代の活動実績" },
      { name: "tel", label: "電話番号" },
      { name: "unofficial_offer_results", label: "内定実績" },
      { name: "full_address", label: "住所" },
      { name: "date_of_birth", label: "生年月日" },
      { name: "grade", label: "学年" },
      { name: "graduate_year", label: "卒業年度" },
      { name: "concentration_name", label: "学科" },
      { name: "seminar_circle", label: "ゼミ・研究室" },
      { name: "course", label: "文理" },
      { name: "schedule", label: "イベント日程" },
      { name: "event_entry_state", label: "参加ステータス" },
      { name: "languages", label: "言語レベル" },
      { name: "self_promotion", label: "自己PR" },
      { name: "student_endeavor", label: "学生時代に頑張ったこと" },
      { name: "entry_route", label: "応募経路" },
      { name: "scheduled_at", label: "イベント開催日時" }
    ];

    const partnerEntryCsvColumns = ref<ApiResponse.PartnerEntryCsvColumn[]>();
    const excludedColumns = ref<CsvColumns[]>([]);
    const includedColumns = ref<CsvColumns[]>([]);

    const runGetPartnerEntryCsvColumns = async () => {
      const response = await getPartnerEntryCsvColumns();
      partnerEntryCsvColumns.value = response.data.csv_columns;
      updateDisplayCsvColumns();
    };

    const updateDisplayCsvColumns = () => {
      if (!partnerEntryCsvColumns.value) {
        return;
      }

      includedColumns.value = [];
      excludedColumns.value = [];

      partnerEntryCsvColumns.value.forEach(item => {
        const csvColumnObj = getCsvColumnObj(item.column);
        if (csvColumnObj) {
          includedColumns.value.push(csvColumnObj);
        }
      });

      excludedColumns.value = availableCsvColumns.filter(item => {
        return !includedColumns.value.find(includedCol => {
          return includedCol.name === item.name;
        });
      });
    };

    const getCsvColumnObj = (column: string) => {
      return availableCsvColumns.find(item => {
        return item.name === column;
      });
    };

    const csvColumnsSaveParams = computed(() => {
      const csvColumns = includedColumns.value.map((item, idx) => {
        return { column: item.name, position: idx };
      });
      // NOTE: partner_entry_offerの出力カラムはOCCでは出力可能カラムに含まれない。
      //       旧管理画面では設定可能なため、併用している時誤って削除されないよう、登録されていれば末尾に追加する。
      //       なお、OCCにおけるCSV出力時にはこの設定は無視される。
      if (
        partnerEntryCsvColumns.value?.find(
          item => item.column === "partner_entry_offer"
        )
      ) {
        const insertIndex = csvColumns.length;
        csvColumns.push({
          column: "partner_entry_offer",
          position: insertIndex
        });
      }
      // NOTE: resume_answersの出力カラムは応募者一覧では出力可能カラムに含まれない。
      //       イベント申込者一覧では設定可能なため、保存時に削除はせず、登録されていれば末尾に追加する。
      //       なお、応募者一覧におけるCSV出力時にはこの設定は無視される。
      if (
        partnerEntryCsvColumns.value?.find(
          item => item.column === "resume_answers"
        )
      ) {
        const insertIndex = csvColumns.length;
        csvColumns.push({
          column: "resume_answers",
          position: insertIndex
        });
      }

      return {
        csv_columns: csvColumns
      };
    });

    const runUpsertPartnerEntryCsvColumns = async () => {
      const response = await upsertPartnerEntryCsvColumns(
        csvColumnsSaveParams.value
      );
      if (response.status !== 204) {
        showCsvDownloadError();
      }
    };

    /** ========================================
     * CSVダウンロード
     * ========================================*/
    const csvDownloadColumns = ref<string[]>();

    const csvDownloadParams = computed(() => {
      return {
        ...searchParams.value,
        output_columns: csvDownloadColumns.value || []
      };
    });

    const onClickCsvDownload = () => {
      resetRowList();
      showCsvCustomizeModal();
    };

    const csvDownloadConfirmModalShow = ref(false);

    const applyCsvDownload = async (items: string[]) => {
      await Promise.all([
        runUpsertPartnerEntryCsvColumns(),
        runCsvDownload(items)
      ]);
    };

    const runCsvDownload = async (items: string[]) => {
      csvDownloadColumns.value = items;
      const response = await startGeneratePartnerEntryUsersCsv(
        csvDownloadParams.value
      );
      if (response.status === 200) {
        csvDownloadConfirmModalShow.value = true;
        resetRowList();
      } else {
        showCsvDownloadError();
      }
    };

    const showCsvDownloadError = () => {
      alertTextList.value = [
        "ダウンロードに失敗しました。リロードして再度お試しください。"
      ];
      showAlert();
    };

    const updateCsvIncludedColumns = (
      newArray: {
        name: string;
        label: string;
      }[]
    ) => {
      includedColumns.value = newArray;
    };
    const updateCsvExcludedColumns = (
      newArray: {
        name: string;
        label: string;
      }[]
    ) => {
      excludedColumns.value = newArray;
    };

    const closeCsvDownloadConfirmModal = () => {
      csvDownloadConfirmModalShow.value = false;
    };

    /** ========================================
     * ステータス一括変更
     * ========================================*/
    const onApplySelectionStatusBulkChange = (
      selectionStatus: PartnerEntryUserSelectionStatus
    ) => {
      toggleIsShowSelectionStatusBulkChangeModal();

      router.push({
        name: "SelectedPartnerEntryUsers",
        query: {
          partnerEntryUserIds: selectedRowList.value.map(partnerEntryUser =>
            String(partnerEntryUser.partner_entry_user.id)
          ),
          selectionStatus
        }
      });
    };

    /** ========================================
     * イベントステータス一括変更
     * ========================================*/
    const newEventStatus = ref<SelectItem<PartnerEntryUserEventStatus> | null>(
      null
    );

    const resetEventStatus = () => {
      newEventStatus.value = null;
    };

    const onChangeEventStatus = async (
      status: SelectItem<PartnerEntryUserEventStatus>
    ) => {
      newEventStatus.value = status;
      showSelectionStatusBulkChangeModal();
    };

    const applyBulkEventStatusEdit = async (
      status: PartnerEntryUserEventStatus
    ) => {
      const data = {
        partner_entry_users: selectedRowList.value,
        status: status
      };
      // TODO: 更新可否をAPIで取得
      const response = { status: 200, data: data };

      if (response.status === 200) {
        bulkEditCount.value = selectedRowList.value.length;
        resetRowList();
        resetEventStatus();
        moveFiresPage();

        runGetPartnerEntryUsers();

        openToast();
        setTimeout(() => {
          closeToast();
        }, 10000);
      } else {
        alertTextList.value = [
          "更新に失敗しました。リロードして再度お試しください。"
        ];
        showAlert();
      }
    };

    /** ========================================
     * トースト
     * ========================================*/
    const toastVisible = ref<boolean>(false);

    const openToast = () => {
      toastVisible.value = true;
    };

    const closeToast = () => {
      toastVisible.value = false;
      resetToastCount();
    };

    const resetToastCount = () => {
      bulkEditCount.value = -1;
    };

    const bulkEditCount = ref<Number>(-1);

    /** ========================================
     * アラート
     * ========================================*/
    const alertVisible = ref<Boolean>(false);

    const alertTextList = ref<string[]>([]);

    const showAlert = () => {
      alertVisible.value = true;
    };

    const closeAlert = () => {
      alertVisible.value = false;
    };

    /** ========================================
     * アラート
     * ========================================*/
    const isLoading = computed<boolean>({
      get: () => {
        return !!usersLoading.value || !!searchOptionsLoading.value;
      },
      set: value => {
        if (value) {
          closeAlert();
          closeToast();
        }
      }
    });

    const currentDateStr = computed<string>(() => {
      return new Date().toISOString().slice(0, 10);
    });

    return {
      searchOptions,
      partnerEntryUsers,
      usersLoading,
      searchOptionsLoading,
      headers,
      hasCsvDownloadPriviledge,
      isShowSelectionStatusBulkChangeModal,
      toggleIsShowSelectionStatusBulkChangeModal,

      filterState,
      leftListFilterConditions,
      rightListFilterConditions,
      filterCount,
      selectItemList,
      hasSelectedEvent,
      onChangeCheckbox,
      onChangeMultiSelect,
      onSearchText,
      onSubmitFilter,
      onResetFilter,

      onApplySelectionStatusBulkChange,

      currentPage,
      displayCount,
      displayCountSelectList,
      totalPageCount,
      onChangePage,
      onChangeDisplayCount,

      onChangeOrderSubColumn,

      toggleStar,

      csvCustomizeModalShow,
      closeCsvCustomizeModal,
      showCsvCustomizeModal,
      csvDownloadConfirmModalShow,
      closeCsvDownloadConfirmModal,
      bulkEditConfirmModalShow,
      closeSelectionStatusBulkChangeModal,
      showSelectionStatusBulkChangeModal,
      updateCsvIncludedColumns,
      updateCsvExcludedColumns,

      selectedRowList,
      selectedRowCount,
      onChangeRowValue,

      onClickCsvDownload,
      applyCsvDownload,
      excludedColumns,
      includedColumns,

      newEventStatus,
      onChangeEventStatus,
      applyBulkEventStatusEdit,
      toastVisible,
      closeToast,
      bulkEditCount,

      alertVisible,
      alertTextList,
      showAlert,
      closeAlert,

      handleChangedEntryDateFrom,
      handleChangedEntryDateTo,
      currentDateStr,

      isLoading
    };
  }
});
